import React from "react";
import ModalBase from "../../../components/common/modal/ModalBase";
import ListBase from "../../list/ListBase";
import { lists } from "../../../utils/list";

interface IModalResult {
  open: boolean;
  onClose: () => void;
  condition?: { [key: string]: any };
}

function ModalResult({ open, condition = {}, onClose }: IModalResult) {
  return (
    <ModalBase open={open} handleClose={onClose} title="Kết quả" width="1200px">
      <ListBase
        category={lists.cr_thuoc}
        defaultCondition={condition}
        hideTop
      />
    </ModalBase>
  );
}

export default ModalResult;
